import * as React from "react";
import { cn } from "../../lib/utils";
import { STATS_BAR_STYLES } from "./constants";
import type { StatsBarProps } from "./types";

export const StatsBar = React.forwardRef<HTMLElement, StatsBarProps>(
  ({ className, items, ...props }, ref) => {
    return (
      <section
        ref={ref}
        className={cn(STATS_BAR_STYLES.root, className)}
        {...props}
      >
        <ul className={STATS_BAR_STYLES.list}>
          {items.map((item) => (
            <li key={item.id} className={STATS_BAR_STYLES.item}>
              {item.iconUrl && (
                <img
                  src={item.iconUrl}
                  alt=""
                  aria-hidden="true"
                  className={STATS_BAR_STYLES.icon}
                  loading="lazy"
                />
              )}
              <span className={STATS_BAR_STYLES.value}>{item.value}</span>
              <span className={STATS_BAR_STYLES.label}>{item.label}</span>
            </li>
          ))}
        </ul>
      </section>
    );
  }
);

StatsBar.displayName = "StatsBar";
